import { useReportingToolsStore } from '@/pages/reporting-tools/store/useReportingToolsStore';
import { MissionSummary } from '@edwin-group/cj-graphql';
import { ArrowDownIcon, ArrowUpIcon, MinusCircleIcon, MinusIcon, PlusCircleIcon } from '@heroicons/react/20/solid';
import { useCallback } from 'react';

export const TraitHeader = ({
  traitExpanded,
  setTraitExpanded,
  missionSummary,
}: {
  traitExpanded: string | null;
  setTraitExpanded: (trait: string | null) => void;
  missionSummary: MissionSummary;
}) => {
  const page = useReportingToolsStore((state) => state.page);

  const renderArrows = useCallback(() => {
    if (missionSummary?.header?.overallImprovement === 'NEUTRAL') {
      return <MinusIcon className="size-10 rounded-full bg-gray-300 p-1.5" />;
    }
    if (missionSummary?.header?.overallImprovement === 'UP') {
      return <ArrowUpIcon className="size-10 rounded-full bg-green-300 p-1.5" />;
    }
    return <ArrowDownIcon className="size-10 rounded-full bg-red-300 p-1.5" />;
  }, [missionSummary?.header?.overallImprovement]);

  return (
    <div className="flex flex-col items-center justify-between md:flex-row">
      <div className="flex flex-col items-center gap-2 md:flex-row">
        {traitExpanded === missionSummary?.header?.trait ? (
          <MinusCircleIcon className="h-6 w-6 cursor-pointer" onClick={() => setTraitExpanded(null)} />
        ) : (
          <PlusCircleIcon
            className="h-6 w-6 cursor-pointer"
            onClick={() => setTraitExpanded(missionSummary?.header?.trait || null)}
          />
        )}
        <h3 className="!mb-0 text-sh-sm !font-bold">{missionSummary?.header?.trait}</h3>
      </div>
      <div className="flex  items-center justify-center gap-5 md:flex-row md:gap-10">
        <div className="flex flex-col items-center justify-center gap-2 text-center md:flex-row">
          <p className="text-sh-sm !font-semibold">{page?.missionSummary.missionsDelivered}</p>
          <div className="flex size-10 items-center justify-center rounded-full border border-black">
            <p className="!mt-0">{missionSummary?.header?.missionsStarted}</p>
          </div>
        </div>
        <div className="flex flex-col items-center justify-center gap-2 text-center md:flex-row">
          <p className="text-sh-sm !font-semibold">{page?.missionSummary.overallImprovement}</p>
          <div>{renderArrows()}</div>
        </div>
      </div>
    </div>
  );
};
